// Le fil d'accueil est passé à React (js/react/ecrans/Fil.jsx).
//
// Les deux pièces les plus délicates restent intactes et sont seulement
// accueillies dans des conteneurs : le bandeau des statuts (`stories.js`) et la
// carte de publication (`posts.js` + `defilement.js`). Migrer ce qui les entoure
// sans y toucher, c'était tout l'intérêt de faire le fil en dernier.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Fil from "../react/ecrans/Fil.jsx";

export const rendre = vueReact(Fil);
